// Centralized data-testid registry for the app
export const HOME = {
  emergentLink: "emergent-link",
};

export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitBtn: "login-submit-btn",
  logoutBtn: "logout-btn",
};

export const NAV = {
  dashboard: "nav-dashboard",
  users: "nav-users",
  templates: "nav-templates",
  assignments: "nav-assignments",
  publish: "nav-publish",
  images: "nav-images",
  audit: "nav-audit",
  settings: "nav-settings",
  help: "nav-help",
};

export const DASHBOARD = {
  root: "dashboard-root",
  cardTotalUsers: "card-total-users",
  cardActiveSignatures: "card-active-signatures",
  cardPendingUsers: "card-pending-users",
  cardLastSync: "card-last-sync",
  graphStatus: "graph-status-indicator",
};

export const USERS = {
  table: "users-table",
  searchInput: "users-search-input",
  syncBtn: "users-sync-btn",
  assignBtn: (id) => `assign-btn-${id}`,
  templateSelect: "user-template-select",
  saveAssignBtn: "save-assign-btn",
};

export const TEMPLATES = {
  list: "templates-list",
  newBtn: "template-new-btn",
  editorRoot: "template-editor-root",
  nameInput: "template-name-input",
  categoryInput: "template-category-input",
  descriptionInput: "template-description-input",
  htmlEditor: "template-html-editor",
  saveBtn: "template-save-btn",
  previewDesktop: "preview-desktop",
  previewMobile: "preview-mobile",
  variablesList: "template-variables-list",
  versionsBtn: "template-versions-btn",
  restoreBtn: (v) => `restore-version-${v}`,
  deleteBtn: (id) => `template-delete-${id}`,
  testMailBtn: "template-test-mail-btn",
  imageStrategyCard: "template-image-strategy-card",
  imageStrategyOption: (v) => `image-strategy-option-${v}`,
  cidAnalyzeBtn: "cid-analyze-btn",
  cidAnalysisResult: "cid-analysis-result",
  cidBadge: (id) => `template-cid-badge-${id}`,
  previewView: (v) => `preview-view-${v}`,
  recipientSummary: "recipient-preview-summary",
  recipientLoading: "recipient-preview-loading",
  recipientEmbeddedCount: "recipient-embedded-count",
  recipientExternalCount: "recipient-external-count",
  compareBtn: (v) => `compare-version-${v}`,
  compareDialog: "version-compare-dialog",
  compareLeftSelect: "compare-left-select",
  compareRightSelect: "compare-right-select",
  compareTab: (t) => `compare-tab-${t}`,
  compareRenderedLeft: "compare-rendered-left",
  compareRenderedRight: "compare-rendered-right",
  compareDiffTable: "compare-diff-table",
  compareDiffStats: "compare-diff-stats",
  compareMetaChanges: "compare-meta-changes",
  compareNoChanges: "compare-no-changes",
  compareRestoreBtn: "compare-restore-btn",
};

export const ASSIGNMENTS = {
  list: "assignments-list",
  addBtn: "assignment-add-btn",
  templateSelect: "assignment-template-select",
  targetTypeSelect: "assignment-target-type",
  targetValueInput: "assignment-target-value",
  priorityInput: "assignment-priority",
  saveBtn: "assignment-save-btn",
  deleteBtn: (id) => `assignment-delete-${id}`,
};

export const PUBLISH = {
  publishBtn: "publish-btn",
  jobsList: "publish-jobs-list",
  progressBar: "publish-progress-bar",
};

export const SETTINGS = {
  tabGraph: "settings-tab-graph",
  tabSmtp: "settings-tab-smtp",
  tabBranding: "settings-tab-branding",
  tabSync: "settings-tab-sync",
  tabProfile: "settings-tab-profile",
  tenantIdInput: "settings-tenant-id",
  clientIdInput: "settings-client-id",
  clientSecretInput: "settings-client-secret",
  testGraphBtn: "settings-test-graph-btn",
  saveGraphBtn: "settings-save-graph-btn",
  saveBrandingBtn: "settings-save-branding-btn",
  saveSmtpBtn: "settings-save-smtp-btn",
  saveSyncBtn: "settings-save-sync-btn",
  profileEmailInput: "profile-email-input",
  profileDisplayNameInput: "profile-display-name-input",
  profileCurrentPasswordInput: "profile-current-password-input",
  profileNewPasswordInput: "profile-new-password-input",
  profileConfirmPasswordInput: "profile-confirm-password-input",
  saveProfileBtn: "settings-save-profile-btn",
};

export const IMAGES = {
  list: "images-list",
  addBtn: "images-add-btn",
  urlInput: "image-url-input",
  nameInput: "image-name-input",
  categorySelect: "image-category-select",
  saveBtn: "image-save-btn",
  deleteBtn: (id) => `image-delete-${id}`,
};

export const AUDIT = {
  list: "audit-list",
};
